module.exports = __webpack_public_path__ + "img/capa2.74caee31.webp";